import type { ErrorEvent } from '@sentry/vue';

// Brave on iOS sometimes runs a Firefox reader-mode probe in the page context without the Firefox
// namespace it requires. These are browser-injected errors, not CX application failures.
const FIREFOX_READER_MODE_ERRORS = [
    {
        type: 'ReferenceError',
        value: "Can't find variable: __firefox__"
    },
    {
        type: 'TypeError',
        value: "undefined is not an object (evaluating 'window.__firefox__.reader')"
    }
] as const;

/** Drop the two known Brave-on-iOS reader-mode injections while retaining every app-originated error. */
export function excludeFirefoxReaderModeErrors(event: ErrorEvent): ErrorEvent | null {
    const isBrowserInjectedReaderModeError = event.exception?.values?.some(exception =>
        FIREFOX_READER_MODE_ERRORS.some(({ type, value }) => exception.type === type && exception.value === value)
    );

    return isBrowserInjectedReaderModeError ? null : event;
}
